module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_vm._v("About The Author")]), _vm._v(" "), _c('p', [_vm._v("Kirk Henderson is an author, screenwriter, art director, and filmmaker. He has written extensively about film and film music, with articles published in a variety of film magazines including "), _c('em', [_vm._v("Music from the Movies")]), _vm._v(", "), _c('em', [_vm._v("Film Score Monthly")]), _vm._v(", and "), _c('em', [_vm._v("Little Shoppe of Horrors")]), _vm._v(". He has created concepts and/or art directed for Lucasfilm, Industrial Light & Magic, and San Francisco’s once vanguard of animation, Colossal Pictures. Mr. Henderson has won awards for his short films, including "), _c('em', [_vm._v("The Visage")]), _vm._v(", currently re-licensed by Shorts Intl. "), _c('em', [_vm._v("Hollywood v. Beauty and the Synchronicity of the Six")]), _vm._v(" is his first book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0